import React, {useEffect} from 'react'
import './About.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Avatar from '../img/facu4.jpg'
import AvatarBack from  '../img/pixelfacu.png'
import locomotiveScroll from 'locomotive-scroll';

function About (){
    
    /*Locomotive Scroll Function*/ 
    const scrollRef = React.createRef();
    useEffect(() => {
        const scroll = new locomotiveScroll({
        el: scrollRef.current,
        smooth: true,
        smartphone: {
            smooth : true,
        },
        getDirection: true,
        getSpeed: true,
        smartphone: {
            smooth: false,
              breakpoint: 767
          },
          tablet: {
              smooth: !1,
              breakpoint: 1024
          },
        });
    });

    return (
        <div className='about' data-scroll-container ref={scrollRef}>
        <h1  >About me</h1>
        <Container className="about__container">
        <Row  className="justify-content-md-center">
        <Col className="avatar__container"> 
        <div className="flip-container" data-scroll  data-scroll-speed="1">
            <div className="flipper">
                <img src={Avatar} alt="Avatar" className="avatar"/>
                <div className="back">
                    <img src={AvatarBack} alt="Avatar" className="avatar"/>
                </div>
            </div>
        </div>
        </Col>
            <Col lg={9} className="about__text" data-scroll data-scroll-speed="-1">
                <h2>Introduction:</h2>
                <p>Hi, i'm Facundo Rodriguez Sabia! </p>
                <p>I have always been drawn to the world of computer science and technology. 
                From a young age, I found myself captivated by the endless possibilities it offers. 
                Today, with six years of experience as a Computer Technician in the support area at DAS 
                (Directorate of Social Assistance for the Staff of the Argentinian National Congress) and my current role as a 
                Semi-Senior Front-End Developer at Wunderman Thompson Argentina for one of its flagship accounts, Colgate-Palmolive, 
                I am thrilled to share my journey and expertise with you.</p>
                <h2>Professional Experience</h2>
                <p>I have spent the last six years honing my skills as a Computer Technician, where I provided valuable support to DAS. My responsibilities ranged from troubleshooting technical issues to ensuring smooth operations for the organization. This experience has equipped me with a strong foundation in IT, which serves as the backbone of my career</p>
                <h2>Transition to Web Development</h2>
                <p>In 2018, I embarked on a journey to explore my passion for web development. I started as a freelance web developer and have since evolved both personally and professionally. My journey into web development began four years ago when I embarked on a self-taught path. Two years ago, I formalized my education by enrolling in the Coderhouse academy, where I pursued a career in Front-End Development. This comprehensive program provided me with essential training in web design, JavaScript, and the ReactJS framework. Additionally, I took an intensive course in Video Game Development using Unity and C#. Currently, I am in the final stages of a Python course, with a focus on the Django framework. These experiences have enriched my skill set and allowed me to diversify my expertise.</p>
                <h2>passion and Future Interests</h2>
                <p>Beyond my professional pursuits, I have a deep-rooted passion for video games, web 3.0, and blockchain technology. I see these areas as exciting frontiers where I can further apply my skills and creativity. My aspiration is to leverage my knowledge in these domains to create innovative and engaging experiences for users and clients alike.</p>
            </Col>
        </Row>
        </Container>
        </div>
    );
}

export default About;